import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import AboutContent from '../components/AboutContent';
import Footer from '../components/Footer';

const About = () => {
  return (
    <div className="About">
      <Header />
      <div className="mt-32 sm:mt-36 lg:mt-32">
        <Hero
          image="/assets/images/about-us.jpeg"
          heightClass="min-h-[80vh] sm:min-h-[90vh] lg:min-h-[110vh]"
          position="center"
          fit="cover"
          backgroundColor="#f5f0eb"
        />
        <AboutContent />
        <Footer />
      </div>
    </div>
  );
};

export default About;
